import {getAxiosInstance, requestConfig} from "../../http-common";

const RESOURCE_NAME = "notifications";

const getAll = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}`, requestConfig());
};

const create = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/create`, model, requestConfig());
};

const createUserNotifications = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/createUserNotifications`, model, requestConfig());
};

const NotificationService = {
  getAll,
  create,
  createUserNotifications,
};
export default NotificationService;
